import * as yup from 'yup'

export class SettingsAutoArchiveAfterImportCancellationDateDto {
  autoArchiveNumberOfDaysAfterCancelImport?: number = undefined
}

export const autoArchiveAfterImportCancellationDateValidationSchema =
  yup.object<SettingsAutoArchiveAfterImportCancellationDateDto>({
    autoArchiveNumberOfDaysAfterCancelImport: yup
      .number()
      .min(0, 'Auto Archive After Import Cancellation Date cannot be less then 0 days.')
      .max(999_999_999_999_999, 'Auto Archive After Import Cancellation Date cannot be more than 999,999,999,999,999 days.')
      .required('Auto Archive After Import Cancellation Date is required.')
  })
